// extracted by mini-css-extract-plugin
export default {"auth":"PopupAuth_auth__VbiyK","lteLgBreakpoint":"PopupAuth_lteLgBreakpoint__JcYxQ"};